var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gip-max-width",attrs:{"id":"supprimer-compte"}},[_c('h1',[_vm._v("Supprimer mon compte")]),_c('p',[_vm._v("Pour supprimer votre compte, veuillez nous envoyer un mail ou nous appeler.")])])
}]

export { render, staticRenderFns }